import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from '@mui/lab';
import { Card, CardContent, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

interface Props {
  sendForm: () => void;
  nextPayment?: string;
  previousPayment?: string;
  pendingPayment?: boolean;
  buttonLoading?: boolean;
}

export const BottomCard: FC<Props> = ({ sendForm, nextPayment, previousPayment, pendingPayment, buttonLoading }) => {
  const { t } = useTranslation();
  return (
    <Card sx={{ mb: 3, mt: 3 }}>
      <CardContent>
        <Grid container gap={2}>
          {
            <LoadingButton
              onClick={sendForm}
              variant="contained"
              data-testid="rent-payment-button"
              disabled={!!nextPayment || pendingPayment}
              loading={buttonLoading}
            >
              {t('issuer.rent.form.pay')}
            </LoadingButton>
          }
          <Grid container flexDirection="column" justifyContent="center">
            {nextPayment && (
              <Typography variant="body1" color="secondary">
                {t('issuer.rent.form.error.pendingPayment', { nextPayment })}
              </Typography>
            )}
            {!nextPayment && previousPayment && (
              <Typography variant="body1" color="secondary">
                {t('issuer.rent.form.error.pastPayment', { previousPayment })}
              </Typography>
            )}
            {pendingPayment && (
              <Typography variant="body1" color="secondary">
                {t('issuer.rent.form.error.pending')}
              </Typography>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
